// extracted by mini-css-extract-plugin
export var readonly = "_is-1";
export var star = "_is-0";